import bbitApi from '@api/make-request'
import {
  IRepository,
  numberArgs,
  IPathParamsArgs,
} from '@api/repositories/i-repository'
import { INationality } from '@app/interfaces/nationality'
import { resolveParams } from '@app/utils/resolve-params/resolve-params'
import { AxiosResponse } from 'axios'

class NationalityRepository implements IRepository<INationality> {
  create(data: INationality): Promise<AxiosResponse<INationality>> {
    return bbitApi.post('/dictionary/api/v1/nationality', data)
  }

  getAll(args: IPathParamsArgs): Promise<AxiosResponse<INationality[]>> {
    return bbitApi.get('/dictionary/api/v1/nationality', {
      cancelToken: args.source?.token,
      params: resolveParams(args),
    })
  }

  getOne(args: numberArgs): Promise<AxiosResponse<INationality>> {
    return bbitApi.get(`/dictionary/api/v1/nationality/${args.data}`, {
      cancelToken: args.source?.token,
    })
  }

  update(data: INationality): Promise<AxiosResponse<INationality>> {
    return bbitApi.put(`/dictionary/api/v1/nationality/${data.id}`, data)
  }
}

export default new NationalityRepository()
